<template>
    <div>

    </div>
</template>

<script>
    import {
        Dialog
    } from 'vant';

    export default {
        name: "Notice",
        components: {
            Dialog,
        },
        props: {
            content: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Notice.vue?2c3ed743